import React from "react";
import { LabeledDate, LabeledText, getFileInfo } from "sprint-common-web";

import { DeliveryType } from "../../../types/DeliveryType";
import { formatBytes } from "../../../utils/formatBytes";
import { BucketDeliveryItem } from "../DeliveryItem";

export interface BucketDeliveryInfoAsideContentProps {
    delivery: BucketDeliveryItem;
}

export const BucketDeliveryInfoAsideContent: React.FunctionComponent<BucketDeliveryInfoAsideContentProps> = (
    props: BucketDeliveryInfoAsideContentProps
) => {
    const { delivery } = props;

    const fileSize = delivery.file.size ? formatBytes(delivery.file.size) : undefined;
    const { name: fileName, extension: fileExtension } = getFileInfo(delivery.file.path);

    return (
        <>
            <LabeledText label="Delivery type" value={DeliveryType[delivery.type]} />
            <LabeledText label="File name" value={`${fileName}.${fileExtension}`} textTooltip={true} />
            <LabeledText label="File size" value={fileSize} />
            <LabeledDate label="Arrival date" value={new Date(delivery.file.arrivalDate)} />
            <LabeledText label="Originator id" value={delivery.originator?.id} textTooltip={true} />
            <LabeledText label="Originator name" value={delivery.originator?.name} textTooltip={true} />
            <LabeledText label="Unique id" value={delivery.bucketInfo.uniqueId} textTooltip={true} />
            <LabeledText label="Bucket name" value={delivery.bucketInfo.bucketName} textTooltip={true} />
        </>
    );
};
